<template>
  <div>
    <div class="dovemed-wrapper search-circles-layout">
      <div class="search-circles-layout__link" @click="goToAllcircles">
        <span class="arrow"><font-awesome-icon size="1x" :icon="['far', 'arrow-left']" /></span><span>BACK</span>
      </div>
      <div class="search-circles-layout__text" v-if="$route.params.type === 'string'">Search Results for "{{ searchKey }}"{{ " " }} ({{ searchCircles.length }})</div>
      <div class="allcircles col-12 m-0 p-0" v-if="searchCircles">
        <div class="mt-5 mt-md-0 p-2" v-for="(circle, index) in searchCircles" :key="index">
          <div class="allcircles-card" :class="circle.enter ? 'joined-circle' : ''">
            <div class="allcircles-card-left">
              <div class="allcircles-card-left--color">
                <div class="allcircles-card-left--top">
                  <div class="allcircles-card-left--color--img" :style="`background-color:${circle.color_code}`"></div>

                  <div class="allcircles-card-left--name">
                    <div v-if="circle.condition_type" class="allcircles-card-left--name--type">
                      {{ circle.condition_type.slice(0, 100) }}
                      {{ circle.condition_type.length > 100 ? "..." : "" }}
                    </div>
                    <div v-if="!circle.enter && circle.description" :class="circle.description ? 'allcircles-card-left--name--description' : 'allcircles-card-left--name--description invisible'">
                      {{ circle.description.slice(0, 60) }}
                      {{ circle.description.length > 60 ? "..." : "" }}
                    </div>
                    <div class="allcircles-card-left--name--ldescription" v-if="circle.long_description && !circle.enter">
                      {{ circle.long_description.slice(0, 250) }}
                      {{ circle.long_description.length > 250 ? "..." : "" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="allcircles-card-right" :style="{ padding: !circle.enter ? '35px' : '0px  35px' }">
              <div class="allcircles-card-right--info" v-if="!circle.enter">
                <div class="m-2 allcircles-card-right--info--box">
                  <div class="allcircles-card-right--info__number">
                    {{ circle.post_count }}
                  </div>
                  <div class="allcircles-card-right--info__text">Posts</div>
                </div>
                <div class="m-2 allcircles-card-right--info--box">
                  <div class="allcircles-card-right--info__number">
                    {{ circle.comment_count }}
                  </div>
                  <div class="allcircles-card-right--info__text">Replies</div>
                </div>
                <div class="m-2 allcircles-card-right--info--box">
                  <div class="allcircles-card-right--info__number">
                    {{ circle.user_count }}
                  </div>
                  <div class="allcircles-card-right--info__text">Members</div>
                </div>
              </div>
              <a-button
                @click="goToCircle(circle, $event)"
                :loading="selectedCircle === circle.condition_type && isLoading"
                :id="circle.enter ? 'enter' : 'register'"
                :style="{
                  color: '#ffffff',
                  background: circle.enter ? '#062b54' : '#1674bf',
                  padding: '12px 45px',
                  width: '100%',
                  'margin-top': '24px',
                  'font-weight': '700',
                }"
                :class="`dovemed-button  ${circle.enter ? 'enter-button' : 'primary-dark-background font-white'} mx-auto uppercase`"
              >
                <span :style="{ color: '#ffffff' }">{{ circle.enter ? "ENTER" : "JOIN" }}</span>
              </a-button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="searchCircles.length === 0" class="no-result">
        <div class="no-result__big">We couldn't find any conditions based on your input.</div>
        <div class="no-result__medium">Send us a message is you want to see MyCircles work on this condition.</div>
        <button @click="$router.push({ name: 'ContactUs' })" id="enter" class="dovemed-button primary-dark-background font-white mt-5 bold-text">CONTACT US</button>
      </div>
    </div>
    <AccVerifyModal ref="accVerify" />
    <SSOModal ref="modal" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import AccVerifyModal from "../../Modals/AccountNotVerifiedWarning.vue"
import { eventBus } from "../../../main"
import SSOLogin from "../../login/login-register-component.vue"
import SSOModal from "../../login/login-register-modal.vue"

const AppRepository = RepositoryFactory.get("app")
const CircleRepository = RepositoryFactory.get("circle")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "searchCircle",

  components: {
    SSOLogin,
    SSOModal,
    AccVerifyModal,
  },

  data() {
    return {
      searchKey: undefined,
      searchCircles: [],
      selectedCircle: "",
      userAdminRoles: ["hospital_administrator", "clinic_administrator", "doctor", "nfp_administrator", "hcp"],
      isSearchGood: false,
      myCircles: [],
      isLoading: false,
    }
  },
  watch: {
    "$route.params.search": function (newVal, oldVal) {
      this.searchCircles = []
      this.newCircleSearch()
    },
  },
  mounted() {
    // this.searchKey = this.$route.params.search;
    // this.init(this.searchKey);
    this.newCircleSearch()
  },
  methods: {
    newCircleSearch() {
      if (this.$route.params.type === "string") {
        this.searchKey = this.$route.params.search
        this.init(this.searchKey)
      } else {
        CircleRepository.all("", this.$route.params.search)
          .then(res => {
            let circle = res.data.data.all_circles[0]
            this.searchKey = circle.condition_type
            this.myCircles = res.data.data ? res.data.data.my_circles : []
            this.authUser && !this.authUser.user.hasOwnProperty("verified_account")
              ? (this.searchCircles = this.circleDiff(res.data.data.all_circles))
              : (this.searchCircles = res.data.data.all_circles)
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    async init(val) {
      //   this.isFetchingCircles = true;
      await CircleRepository.all(val, "")
        .then(async res => {
          this.isSearchGood = res.data.data ? true : false
          if (res.data.data) {
            this.isSearchGood = true
            this.myCircles = this.authUser ? res.data.data.my_circles : []
            this.authUser && !this.authUser.user.hasOwnProperty("verified_account")
              ? (this.searchCircles = await this.circleDiff(res.data.data.all_circles))
              : (this.searchCircles = await res.data.data.all_circles)
          } else {
            this.searchCircles = []
          }
        })
        .catch(err => {})
    },
    circleDiff(searchCircles) {
      if (this.authUser) {
        searchCircles.forEach(a => {
          const found = this.myCircles.some(b => b.id === a.id)
          if (found) {
            a["enter"] = true
          }
        })

        return searchCircles
      }
    },

    goToAllcircles() {
      this.$router.replace({
        name: "AllCircles",
      })
    },
    /**
     * Go to diffeent circle page based on user selection
     *
     * @param {Object} circle
     * @param {Object} event
     */
    goToCircle(circleInfo, event) {
      this.isLoading = true
      this.selectedCircle = circleInfo.condition_type
      const target = event.target.id

      CircleRepository.all("", circleInfo.id)
        .then(res => {
          let circle = res.data.data.all_circles[0]
          if (!this.authUser) {
            document.body.scrollTop = 0
            setTimeout(() => {
              this.$refs.modal.open()
              this.isLoading = false
            }, 100)
          } else if (this.authUser && this.authUser.user.hasOwnProperty("verified_account") && this.authUser.user.verified_account === false) {
            this.$refs.accVerify.showModal()
            this.isLoading = false
          } else {
            this.$store.dispatch("Circle/diseaseTypes", { type: circle.id })
            this.$store.commit("Circle/setCurrentCircle", { data: circle })
            target === "enter" ? this.checkAndRoute(circle) : this.goToCircleDescription(circle)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    goToCircleDescription(data) {
      this.$store.dispatch("Circle/diseaseTypes", { type: data.id })
      this.$store.commit("Circle/setCurrentCircle", { data: data })
      this.$router.push({
        name: "CircleDescription",
        params: {
          circle: this.currentCircle.key_name,
        },
        query: {
          circle_id: this.currentCircle.id,
        }
      })
    },

    checkAndRoute(circle) {
      AppRepository.getHasMultiRole(this.currentCircle.id)
        .then(res => {
          if (!res.data.data.length) {
            let selectedRole
            selectedRole = this.$store.state.User.user.user.multiRole.filter(r => r.circle_id === this.currentCircle.id)[0].role
            const payload = { role: selectedRole, circle_id: this.currentCircle.id }
            AppRepository.postHasMultiRole(payload).then(res => {
              UserRepository.getSelfProfile(this.authUser.user, circle.id).then(res => {
                console.log("I AM CALLING")
                this.$store.state.User.user.user.display_name = res.data.data.user_info.display_name || "D"
                // this.$store.state.User.user.user.display_name = res.data.data.user_info.display_name ? res.data.data.user_info.display_name.toLowerCase() : "D"
                this.authUser.user.role = selectedRole
                this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
              })
            })
          }
          if (res.data.data.length === 1) {
            const payload = {
              role: res.data.data[0].role,
              circle_id: this.currentCircle.id,
            }
            AppRepository.postHasMultiRole(payload).then(res => {
              UserRepository.getSelfProfile(this.authUser.user, circle.id).then(res => {
                console.log("I AM CALLING")
                this.authUser.user.display_name = res.data.data.user_info.display_name || "D"
                // this.authUser.user.display_name = res.data.data.user_info.display_name ? res.data.data.user_info.display_name.toLowerCase() : "D"
                this.authUser.user.role = payload.role
                this.authUser.user.first_post = res.data.data.user_info.first_post
                this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
              })
            })
          }
          if (res.data.data.length > 1) {
            this.$router.push(`/${this.currentCircle.key_name}/select-profile`)
          }
        })
        .catch(err => {})
    },
  },
}
</script>

<style scoped lang="scss">
.no-result {
  text-align: center;
  padding-bottom: 35px;
  background: #f7f8fa;

  &__big {
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
    margin-bottom: 24px;
    padding-top: 48px;
  }

  &__medium {
    font-size: 16px;
    line-height: 14px;
  }
}
.enter-button {
  background: #062b54;
  color: #ffffff !important;
}
.search-circles-layout {
  margin: 0 auto;
  cursor: pointer;
  min-height: 100vh;

  &__text {
    font-size: 32px;

    font-weight: bold;
    margin-bottom: 28px;
    margin-top: 48px;
  }

  &__link {
    padding: 48px 20px 20px 0px;
    color: blue;
    span {
      color: blue;
      margin-left: 5px;
      font-weight: bold;
      line-height: 15px;
      font-size: 12px;
    }
  }
}
.allcircles {
  position: relative;
  &-card {
    min-height: 200px;
    margin: auto;
    background-color: #ffffff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    border-radius: 8px;
    display: flex;
    padding: 20px;
    margin-bottom: 20px;

    @media screen and (max-width: 900px) {
      max-height: 450px;
      flex-direction: column;
      padding: 30px 0px;
    }

    &-left {
      min-width: 720px;
      margin-right: 20px;
      @media screen and (max-width: 1200px) {
        margin-right: 0px;
        min-width: 490px;
        // margin-top: -65px;
      }
      @media screen and (max-width: 900px) {
        margin-right: 0px;
        min-width: fit-content;

        // margin-top: -65px;
      }
      &--top {
        display: flex;
        margin-bottom: 18px;
        margin-left: 16px;
        @media screen and (max-width: 900px) {
          display: flex;

          margin-bottom: 0px;
          align-items: center;
        }
      }
      &--color {
        &--img {
          height: 60px;
          width: 60px;
          border-radius: 50%;
          background-color: #0dcbbb;
          display: flex;
          flex-shrink: 0;
          // @media screen and (max-width: 900px) {
          //   position: absolute;
          //   transform: translate(50%, 50%);
          // }
        }
      }

      &--name {
        display: flex;
        flex-direction: column;
        padding-left: 16px;

        @media screen and (max-width: 900px) {
          display: flex;
        }

        &--type {
          font-weight: 700;
          font-size: 24px;
          margin-bottom: 18px;
        }
        &--ldescription {
          font-size: 16px;
          line-height: 30px;
          @media screen and (max-width: 1200px) {
            display: none;
          }
        }
        &--description {
          font-size: 16px;
          line-height: 19px;
          font-style: italic;
          font-weight: bold;
          margin-bottom: 16px;
          overflow: hidden;

          @media screen and (max-width: 1200px) {
            margin-bottom: 0px;
          }
        }
      }
    }

    &-center {
      min-width: 486px;
      max-width: 486px;
      font-size: 16px;
      line-height: 28px;

      @media screen and (max-width: 1200px) {
        overflow: hidden;
      }

      @media screen and (max-width: 900px) {
        display: none;
      }
    }

    &-right {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      justify-content: center;

      @media screen and (max-width: 900px) {
        margin-top: 16px;
      }

      &--info {
        display: flex;
        font-weight: bold;

        @media screen and (max-width: 900px) {
          margin-top: 20px;

          width: 100%;
          // display: flex;
          justify-content: center;
        }

        &--box {
          padding: 14px 14px 16px 24px;
          background: rgba(6, 43, 84, 0.03);
          border-radius: 3px;
        }

        &__text {
          font-size: 14px;
          line-height: 14px;
        }

        &__number {
          font-size: 18px;
          line-height: 18px;
          margin: 3px;
        }
      }

      .dovemed-button {
        // padding: 13px 84px;
        width: 100%;
        font-weight: bold;
        margin-top: 24px;

        @media screen and (max-width: 900px) {
          padding: 13px 84px;
          width: fit-content;
        }
      }
    }
  }
}
.joined-circle {
  min-height: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/App/circle/searchCircle.vue